<template>
  <component
    :is="element"
    :class="['button', classObj]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <BtnSpinner
      :class="['button__spinner', { actived: busy }]"
      :color="spinnerColor"
    />
    <slot />
  </component>
</template>

<script>
import BtnSpinner from '@/components/BtnSpinner';

export default {
  name: 'Button',

  components: { BtnSpinner },

  props: {
    secondary: {
      type: Boolean,
      default: false,
      required: false,
    },
    busy: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  computed: {
    element() {
      const { to, href } = this.$attrs;
      return to ? 'router-link' : href ? 'a' : 'button';
    },

    classObj() {
      const { secondary, busy } = this;

      return { secondary, busy };
    },

    spinnerColor() {
      return this.secondary ? undefined : '#fff';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
